
    <div class="cnt-column-centered popup-body" [style]="parent.bodyStyle" attr.data-testid="{{parent.testId}}-dialog">
        <div [height]="20"></div>
        <div style="width: 100%">
            <div *ngIf="!parent.isXeroDisconnect" class="textBody" [innerHtml]="parent.bodyText"></div>
            <ng-container *ngIf="parent.isXeroDisconnect">
                <div class="xeroTextBody" i18n>{{ 'DISCONNECTING' | translate }} <span class="b1Color h4Font">{{parent.companyName}}</span> {{ 'WILL_REMOVE_YOUR_XERO_DATA_FROM_THIS_PLAN' | translate }}.</div>
                <br/>
                <ng-container *ngIf="parent.plansCount > 0">
                    <div class="xeroTextBody" i18n>{{ 'YOU_ALSO_HAVE' | translate }} <span class="b1Color h4Font">{{parent.plansCount}} {{ 'OTHER_PLANS' | translate }} </span> {{ 'CONNECTED_TO' | translate }} <span class="b1Color h4Font">{{parent.companyName}}.</span></div>
                    <br/>
                    <div class="xeroTextBody" i18n>{{ 'THE_DATA_IN_THESE_PLANS_WILL_NOT_BE_CHANGED_BUT_THEY_WILL_NOT' | translate }}</div>
                    <div class="xeroTextBody" i18n>{{ 'UPDATE_UNTIL_YOU_REAUTHORIZE_THIS_COMPANY_AGAIN' | translate }}.</div>
                </ng-container>
            </ng-container>

        </div>

        <div class="buttons cnt-row-centered" [style.margin-top.px]="parent.buttonsTopMargin">

            <ng-container *ngFor="let item of parent.buttonArray; let i = index;">

                <simple-btn *ngIf="item.isAction"
                        [style.marginRight]="'10px'"
                        [width]="item.width"
                        [backgroundFillCls]="'o2Background'"
                        [hoverFillCls]="'o1Background'"
                        [boxShadowCls]="'primary-shadow'"
                        [textCls]="'large-btn-text'"
                        [height]="40"
                        [cornerRadius]="50" 
                        [horizontalPadding]="20"
                        [text]="item.title"
                        (click)="handleButtonClick(item)"
                        [disabled]="btnDisabled"
                        attr.data-testid="{{item.testId}}-button">
                </simple-btn>
                
                <simple-btn *ngIf="!item.isAction"
                        [style.marginRight]="'10px'"
                        [width]="item.width"
                        [backgroundFillCls]="'transparent-background'"
                        [hoverFillCls]="'g4Background'"
                        [borderWidth]=2
                        [borderColorCls]="'g4Border'"
                        [hoverBorderColorCls]="'g4Border'"
                        [textColorCls]="'g4Color'"
                        [hoverTextColorCls]="'white-color'"
                        [textCls]="'large-btn-text'"
                        [height]="40"
                        [cornerRadius]="50" 
                        [horizontalPadding]="20"
                        [text]="item.title"
                        (click)="handleButtonClick(item)"
                        [disabled]="btnDisabled"
                        attr.data-testid="{{item.testId}}-button">
                </simple-btn>
                
            </ng-container>

        </div>
    </div>

